import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentMethodsComponent } from './payment-methods.component';
import { ReactiveFormsModule } from '@angular/forms';
import { InputsGeneratorModule } from '../inputs-generator/inputs-generator.module';
import { DirectivesModule } from '../../directives/directives.module';
import { createCustomElement } from '@angular/elements';
import { UnzerComponent } from './method/unzer/unzer.component';
import { ElvComponent } from './method/elv/elv.component';
import { UmsbankingComponent } from './method/umsbanking/umsbanking.component';
import { DialogModule } from 'primeng/dialog';
import { FormUtilitiesModule } from '../../ds24-ui/form-utilities';
import { StripeComponent } from './method/stripe/stripe.component';
import { HeidelpayCcComponent } from './method/heidelpay-cc/heidelpay-cc.component';
import { BraintreeComponent } from './method/braintree/braintree.component';
import { KlarnaComponent } from './method/klarna/klarna.component';
import { CvcDialogComponent } from './cvc-dialog/cvc-dialog.component';
import { VenmoComponent } from './method/venmo/venmo.component';
import { SanitizePipeModule } from '@digistore/ds24-ui/pipes';
import { PipesModule } from '../../pipes/pipes.module';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { StripeV2Component } from './method/stripe-v2/stripe-v2.component';
import { StripeSepaV2Component } from './method/stripe-sepa-v2/stripe-sepa-v2.component';
import { PaymentExpressCheckoutComponent } from '../../widgets/payment-express-checkout/payment-express-checkout.component';
import { PrimerComponent } from './method/primer/primer.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { PrimerPaypalComponent } from './method/primer/primer-paypal/primer-paypal.component';
import { PrimerGoogleApplePayComponent } from './method/primer/primer-ga/primer-ga.component';
import { IconModule, ModalModule } from '@ds24/elements';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PrimerConfirmModalComponent } from './method/primer/primer-confirm-modal/primer-confirm-modal.component';

@NgModule({
  declarations: [
    PaymentMethodsComponent,
    UnzerComponent,
    ElvComponent,
    UmsbankingComponent,
    StripeComponent,
    StripeV2Component,
    StripeSepaV2Component,
    HeidelpayCcComponent,
    BraintreeComponent,
    CvcDialogComponent,
    VenmoComponent,
    KlarnaComponent,
    PrimerComponent,
    PrimerPaypalComponent,
    PrimerGoogleApplePayComponent,
    PrimerConfirmModalComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputsGeneratorModule,
    DirectivesModule,
    PipesModule,
    SanitizePipeModule,
    DialogModule,
    FormUtilitiesModule,
    CreditCardDirectivesModule,
    PaymentExpressCheckoutComponent,
    MatButtonToggleModule,
    ModalModule,
    IconModule,
    MatProgressSpinnerModule,
  ],
})
export class PaymentMethodsModule {
  static initialize(injector: Injector) {
    const customComponent = createCustomElement(PaymentMethodsComponent, {
      injector: injector,
    });
    customElements.define('ds-orderform-payment-methods', customComponent);
  }
}
